'use client'

/**
 * 이벤트(마케팅) 페이지 전용 CTA 버튼 — **디자인시스템 버튼이 아니다**.
 *
 * 이벤트마다 CMS가 배경·글자색을 헥사 코드로 지정하는데, edsn 버튼은 variant·color 축만 있어
 * 임의 색을 받지 못하고 파운데이션 시맨틱으로도 표현되지 않는다. 그래서 이 화면의 CTA는
 * DS 규칙을 따르지 않고 DS 밖에서 직접 그린다.
 *
 * 치수·타이포는 마이그레이션 전 구 eds 버튼 size="m"을 그대로 복원했다
 * (높이 50 · 패딩 12/30 · 반경 8 · 16px Bold).
 * 비활성 시에는 구 동작과 같이 CMS 색을 무시하고 회색으로 떨어진다.
 */

/** CMS가 색을 안 주거나 헥사 코드가 아닐 때의 기본색 — 검정 배경 + 흰 글자. */
const DEFAULT_BG = '#000000'
const DEFAULT_COLOR = '#ffffff'

/** 구 eds 버튼 disabled 토큰(bg-border-200 / text-label)에 대응하는 값. */
const DISABLED_BG = '#dee2e5'
const DISABLED_COLOR = '#858d94'

/** CSS가 실제로 해석하는 헥사 길이만 통과시킨다(#RGB · #RGBA · #RRGGBB · #RRGGBBAA). */
const HEX_COLOR = /^#([0-9a-fA-F]{3,4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/

/** 헥사 코드면 그대로, 아니면 기본색으로 떨어뜨린다. */
function hexOr(value: string | undefined | null, fallback: string): string {
  if (!value) return fallback
  const hex = value.trim()
  return HEX_COLOR.test(hex) ? hex : fallback
}

type Props = {
  label?: string
  onClick?: () => void
  disabled?: boolean
  fullWidth?: boolean
  /** CMS 원본 값. 헥사 코드면 그대로 쓰고, 아니면 기본색으로 떨어진다. */
  bgColor?: string
  color?: string
}

export default function MarketingButton({
  label,
  onClick,
  disabled = false,
  fullWidth = false,
  bgColor,
  color
}: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={[
        'inline-flex items-center justify-center gap-[4px] box-border',
        'h-[50px] py-[12px] px-[30px] rounded-[8px] border-0 appearance-none',
        'text-[16px] leading-normal',
        disabled ? 'font-normal cursor-not-allowed' : 'font-bold cursor-pointer',
        fullWidth ? 'w-full' : ''
      ]
        .filter(Boolean)
        .join(' ')}
      // 비활성은 구 동작(!important로 덮어쓰기)과 같이 CMS 색보다 우선한다.
      style={{
        backgroundColor: disabled ? DISABLED_BG : hexOr(bgColor, DEFAULT_BG),
        color: disabled ? DISABLED_COLOR : hexOr(color, DEFAULT_COLOR)
      }}
    >
      {label}
    </button>
  )
}
